import React, { ReactNode } from 'react';
import {
  getHoldrFeedDropdownOptions,
  getNewsFeedDropdownOptions,
  getSharedFeedDropdownOptions,
  getSocialFeedDropdownOptions,
} from '../components/dropdown/utils/getOptions';
import { RenderNode } from '../types/v2/utils';

export const renderNode: RenderNode = (children, text) => {
  if (children && !text) {
    return children;
  } else if (text && !children) {
    return text;
  }
};

export function getSubComponent<T>(children: ReactNode, displayName: T) {
  return React.Children.map(children, (child: any) =>
    child.type.displayName === displayName ? child : null
  );
}

export function getSubComponentStyles(component: any) {
  if (!component || !component[0]) return '';
  return component && component[0].props.className;
}

export function getFeedDropdownOptions(
  category: 'news' | 'social' | 'holdr',
  text: string
) {
  let feedDropdownOptions = getSharedFeedDropdownOptions();

  switch (category) {
    case 'news':
      return [...getNewsFeedDropdownOptions(text), ...feedDropdownOptions];
    case 'holdr':
      return [...getHoldrFeedDropdownOptions(text), ...feedDropdownOptions];
    default:
      return [...getSocialFeedDropdownOptions(), ...feedDropdownOptions];
  }
}
